import * as React from "react";
import {
    Grid
} from "@material-ui/core";
import ColorItem from "./color-item"

const ColorChanger = ({ tags }: any) => {
    return (
        <Grid
            container
            xs={12}
            style={{
                display: "flex",
                gap: 4,
                padding: "8px",
            }}
        >
            {tags.map((tag: any, index: number) => {
                return (
                    <ColorItem key={index} index={index} tag={tag} />
                )
            })}
        </Grid>
    )
}

export default ColorChanger